module.exports = __webpack_public_path__ + "030fdbbdb3afdfd579f468d66200f7c9.svg";